module.exports = __webpack_public_path__ + "img/15-sdg-border@2x.daf3aaee.png";